var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPriceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49805 11.8335L10.1647 9.16683M7.49805 9.16683H7.50405M10.1587 11.8335H10.1647M8.83138 15.1668C10.2459 15.1668 11.6024 14.6049 12.6026 13.6047C13.6028 12.6045 14.1647 11.248 14.1647 9.8335C14.1647 5.8335 8.83138 1.8335 8.83138 1.8335C8.57271 3.4915 8.31938 4.3815 7.49805 5.8335C6.69805 5.4635 6.49805 5.16683 6.16471 4.3335C4.83138 5.8335 3.49805 7.8335 3.49805 9.8335C3.49805 11.248 4.05995 12.6045 5.06014 13.6047C6.06034 14.6049 7.41689 15.1668 8.83138 15.1668Z",
    stroke: "#38B000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceIcon);
export default __webpack_public_path__ + "static/media/price-icon.d0609620fe78e78fe5cbe9a55fab21e0.svg";
export { ForwardRef as ReactComponent };